import * as R from 'ramda'

import { dbToTree } from 'src/lib/graph/walk'

export function inheritFeature(state, action) {
  const { feature, networkId } = action.payload
  const network = dbToTree(
    networkId,
    [':network/features', ':network/disabled-features'],
    state
  )

  return R.pipe(
    R.assocPath(
      [networkId, ':network/features'],
      R.without(feature, network[':network/features'])
    ),
    R.assocPath(
      [networkId, ':network/disabled-features'],
      R.without(feature, network[':network/disabled-features'])
    )
  )(state)
}

export function optInFeature(state, action) {
  const { feature, networkId } = action.payload
  const network = dbToTree(
    networkId,
    [':network/features', ':network/disabled-features'],
    state
  )

  return R.pipe(
    R.assocPath(
      [networkId, ':network/features'],
      R.concat(R.propOr([], ':network/features', network), [feature])
    ),
    R.assocPath(
      [networkId, ':network/disabled-features'],
      R.without(feature, R.propOr([], ':network/disabled-features', network))
    )
  )(state)
}

export function optOutFeature(state, action) {
  const { feature, networkId } = action.payload
  const network = dbToTree(
    networkId,
    [':network/features', ':network/disabled-features'],
    state
  )

  return R.pipe(
    R.assocPath(
      [networkId, ':network/disabled-features'],
      R.concat(R.propOr([], ':network/disabled-features', network), [feature])
    ),
    R.assocPath(
      [networkId, ':network/features'],
      R.without(feature, R.propOr([], ':network/features', network))
    )
  )(state)
}
